import { inject, Injectable, signal } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Router, RoutesRecognized } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class PreviousUrlService {
	router = inject(Router);
	public urlStack = signal<string[]>([]);

	constructor() {
		this.router.events
			.pipe(filter((evt: any) => evt instanceof RoutesRecognized))
			.subscribe((events: RoutesRecognized) => {
				this.urlStack.update(prev => [events.urlAfterRedirects, ...prev]);
			});
	}

	goBack() {
		if (this.urlStack().length > 1) {
			this.router.navigate([this.urlStack()[1]]);
		} else {
			this.router.navigate(['/menu']);
		}
		this.urlStack.update(prev => {
			prev.shift();
			prev.shift();
			return prev;
		});
	}
}
